import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// lodash
import get from 'lodash/get';
//
import Select from 'jl-design-system/elements/select/Select';
// redux
import { connect } from 'react-redux';
import { setCanMakeApplePayPayments } from '../../../redux/actions/payment/applePayActions';
import { setCanMakeGooglePayPayments, enableGooglePayStubs } from '../../../redux/actions/payment/googlePayActions';
import loadPaymentWalletStubs from '../../utils/paymentWallet/loadPaymentWalletStubs';
// styles
import styles from './payment-wallet-stubs.scss';

export class PaymentWalletStubs extends PureComponent {

  static propTypes = {
    enableGooglePayStubs: PropTypes.func,
    setCanMakeApplePayPayments: PropTypes.func,
    setCanMakeGooglePayPayments: PropTypes.func,
    stubName: PropTypes.string,
  };

  static defaultProps = {
    enableGooglePayStubs: window.defaultFunc,
    setCanMakeApplePayPayments: window.defaultFunc,
    setCanMakeGooglePayPayments: window.defaultFunc,
    stubName: '',
  };

  static mockData = undefined;

  constructor(props) {
    super(props);

    this.state = {
      mockData: undefined,
      stub: '',
      options: [],
    };
  }

  async componentDidMount() {
    const { stubName } = this.props;

    const stubData = await loadPaymentWalletStubs(stubName);
    this.setState(stubData, () => {
      // eslint-disable-next-line no-eval
      eval(get(stubData.mockData, 'script'))(...Object.values(stubData.payload));
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { stub } = this.state;
    if (prevState.stub !== stub) {
      this.setStub();
    }
  }

  setStub() {
    const { mockData, payload } = this.state;
    // eslint-disable-next-line no-eval
    eval(get(mockData, 'script'))(...Object.values(payload));
  }

  onStubSelect = (evt) => {
    const { setCanMakeApplePayPayments, setCanMakeGooglePayPayments, enableGooglePayStubs } = this.props;

    if (get(evt, 'target.value')) {

      if (evt.target.value === 'ApplePay is eligible') {
        setCanMakeApplePayPayments();
      }

      if (evt.target.value === 'Google Pay is eligible') {
        enableGooglePayStubs(true);
        setCanMakeGooglePayPayments(new window.google.payments.api.PaymentsClient({ environment: 'TEST' }));
      }

      const value = evt.target.value;
      const { mockData } = this.state;
      const payload = get(mockData, `stubs.${value}`);
      this.setState({
        stub: value,
        payload,
      });
    }
  };

  render() {
    const { options, stub } = this.state;
    return (
      <div className={styles.paymentWalletStubs}>
        <Select
          id="payment-wallet-stubs"
          name="payment-wallet-stubs"
          onChange={this.onStubSelect}
          options={options}
          value={stub}
        />
      </div>
    );
  }
}

export default connect(null, {
  enableGooglePayStubs,
  setCanMakeApplePayPayments,
  setCanMakeGooglePayPayments,
})(PaymentWalletStubs);
